import {
  getMyTopics,
  getLatestTopics,
  getMyCategoryTopics,
  getLatestCategoryTopics,
  getTopic,
  getCategoryTopics,
  getMyLatestTopics
} from '@/api/topics-api';
import types from './types';
import { ITopicMessage } from '@/interfaces/topic-messages.interface';

const actions = {
  async FETCH_MY_TOPICS(store: any): Promise<any> {
    try {
      const topicsResult = await getMyTopics();
      store.commit(types.mutations.SET_MY_TOPICS, topicsResult.data);
    } finally {
      return Promise.resolve();

    }
  },

  async FETCH_LATEST_TOPICS(store: any): Promise<any> {
    try {
      const topicsResult = await getLatestTopics();
      store.commit(types.mutations.SET_LATEST_TOPICS, topicsResult.data);
    } finally {
      return Promise.resolve();

    }
  },

  async FETCH_MY_LATEST_TOPICS(store: any): Promise<any> {
    try {
      const topicResult = await getMyLatestTopics();
      store.commit(types.mutations.SET_MY_LATEST_TOPICS, topicResult.data);
    } finally {
      return Promise.resolve();

    }
  },

  async FETCH_MY_CATEGORY_TOPICS(store: any, params: any): Promise<any> {
    try {
      const topicsResult = await getMyCategoryTopics(params.id);
      store.commit(types.mutations.SET_MY_CATEGORY_TOPICS, topicsResult.data);
    } finally {
      return Promise.resolve();
    }
  },

  async FETCH_LATEST_CATEGORY_TOPICS(store: any, params: any): Promise<any> {
    try {
      const topicsResult = await getLatestCategoryTopics(params.id);
      store.commit(types.mutations.SET_LATEST_CATEGORY_TOPICS, topicsResult.data);
    } finally {
      return Promise.resolve();

    }
  },

  async FETCH_CATEGORY_TOPICS(store: any, catId: any): Promise<any> {
    try {
      const topicsResult = await getCategoryTopics(catId);
      store.commit(types.mutations.SET_TOPICS, topicsResult.data);
    } finally {
      return Promise.resolve();

    }
  },

  async FETCH_TOPIC(store: any, params: any): Promise<any> {
    try {
      const topicResult = await getTopic(params.id);
      store.commit(types.mutations.SET_ACTIVE_TOPIC, topicResult.data);
    } finally {
      return Promise.resolve();

    }
  },

  OPEN_MESSAGE_REPORT_DIALOG(store: any, topicMessage: ITopicMessage): void {
    store.commit(types.mutations.SET_REPORTING_TOPIC_MESSAGE, topicMessage);
  }
};

export default actions;
